/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { IconEdit } from "@tabler/icons-react";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import { useUpdateLink } from "cms/rich-text/simplicity-composer-tiptap/tiptap-extensions/simplicity-link/use-update-link";
import { useCurrentEditor } from "@tiptap/react";

export const LinkDisplay = (props) => {
    
    const setOpen = props?.setOpen;
    
    const { t } = useTranslation();
    const { editor } = useCurrentEditor();
    const { link } = useUpdateLink();
    
    useEffect(() => {
        const guid = link?.guid;
        if (guid === null) {
            setOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [link]);
    
    const onOpenLinkSelector = () => {
        setOpen(true);
    };
    
    const onRemoveLink = () => {
        editor.chain().focus().extendMarkRange("link").unsetMark("link").run();
        setOpen(false);
    };
    
    return (
        <div className="simplicity-richtext-composer-editor-tooltip">
            <span className='simplicity-richtext-composer-editor-tooltip-text'>
                {link?.url}
            </span>
            <div className='simplicity-richtext-composer-editor-tooltip-buttons'>
                <div>
                    <Button
                        variant='text'
                        onClick={onOpenLinkSelector}
                        startIcon={<IconEdit/>}
                    >
                        {t("Editor.edit")}
                    </Button>
                </div>
                <div>
                    <Button
                        variant='text'
                        onClick={onRemoveLink}
                    >
                        {t("Editor.remove")}
                    </Button>
                </div>
            </div>
        </div>
    );
};
